<template lang="pug">
  BlueSearch
    template(#default="{results}")
      .flow-resources-search
        .flow-resources-search__wrapper
          button.btn.flow-resources-search__rail-toggle(@click="filtersVisible = !filtersVisible") {{ toggleText }}
          .flow-resources-search__rail(:class="{'visible': filtersVisible}")
            SearchFilters
              template(#default="{executeSearch, filters, setFilterValue, clearAllFilters}")
                Filters(
                  :filters="filters",
                  :results="results",
                  :clearAllFilters="clearAllFilters",
                  :setFilterValue="setFilterValue",
                  :executeSearch="executeSearch",
                  @search="filtersVisible = false;"
                )

          .flow-resources-search__content

            .flow-resources-search__results
              SearchResults
                template(#item="{ result, openInNewWindow, formatDate }")
                  Result(
                    :result="result",
                    :openInNewWindow="openInNewWindow",
                    :formatDate="formatDate"
                  )
            .flow0-resources-search__pagination
              SearchPagination
</template>

<script>
import Filters from "./components/Filters.vue";
// import Sort from "./components/Sort.vue";
// import Query from "./components/Query.vue";
import Result from "./components/Result.vue";

export default {
  name: "DoctorSearch",
  data() {
    return {
      filtersVisible: false,
    }
  },
  computed: {
    toggleText() {
      return this.filtersVisible ? 'Hide Filters' : 'Show Filters';
    }
  },
  components: {
    // Sort,
    // Query,
    Result,
    Filters
  },
  method: {}
};
</script>

<style lang="scss" scoped>
#bluesearch {
  @include mqdn(lg) {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
  }

  &::v-deep {
    .search-pagination[class] {
      display: flex;
      justify-content: center;
    }

    .search-pagination__number[class],
    .search-pagination__ellipsis[class] {
      //	display: none;
    }

    .search-pagination__number[class] {
      height: 1.5rem;
      width: 1.5rem;
      font-size: .875rem;
    }

    .search-pagination__prev,
    .search-pagination__next {
      background: transparent;
      font-size: .875rem;
      position: relative;
      width: unset;
      color: #45545F;

      &:after {
        border: 0;
        width: unset;
        height: unset;
        transform: unset;
      }

      &:before {
      }
    }

    .search-pagination__prev {
      margin-right: 1.5rem;

      &:after {
        content: 'PREV';
      }

      &:before {
        @include icon;
        content: '\e906';
        padding-right: .5rem;
      }
    }

    .search-pagination__next {
      margin-left: 1.5rem;

      &:after {
        @include icon;
        content: '\e907';
        padding-left: .5rem;
      }

      &:before {
        content: 'NEXT';
      }
    }
  }
}
</style>
<style lang="scss">
* {
  text-transform: none;
  text-decoration: none;
  font-family: $fontFamilyBase;
  font-weight: $fontWeightBase;
}

.search {
  cursor: unset !important;

  &::before {
    background: transparent !important;
  }
}

.flow-resources-search {
  display: flex;
  flex-direction: column;
  width: 100%;

  .loader {
    display: block !important;
  }

  &__query {
    width: 100%;
  }

  &__wrapper {
    display: flex;
    @include mqdn(lg) {
      flex-direction: column;
    }
  }

  &__rail {
    padding-bottom: 2rem;
    overflow: hidden;
    transition: ease .35s;
    @include mq(md) {
      flex: 0 0 20rem;
      padding-right: 2rem;
      padding-bottom: 0;
    }
    @include mqdn(md) {
      max-height: 0;
      &.visible {
        max-height: 60rem;
      }
    }
    &-toggle {
      @include mq(md) {
        display: none;
      }
    }
  }

  &__content {
    flex: 1;
  }

  &__pagination {
    flex: 0 0 100%;
    display: flex;
    justify-content: flex-end;
  }
}

#bluesearch {
  @include container();
  //--link-color: #{$red};
  //--link-hover-color: #{darken($red, 10%)};
  //--loader-color: #{$red};
  //--pagination-number-color: #{$darkGray};
  //--pagination-number-background: transparent;
  //--pagination-number-hover-color: #{$white};
  //--pagination-number-hover-background: #{$iceGray};
  //--pagination-number-active-color: #{$white};
  //--pagination-number-active-background: #{$red};
  //--pagination-nav-hover-background: #{$darkGray};
  //--pagination-nav-background: #{$gray};
  --button-color: #131515;
  --button-background: #EDEFF0;
  --button-hover-color: #131515;
  --button-hover-background: #{darken(#EDEFF0, 10%)};

  //--font-size: /* property value */;
  //--font-weight: /* property value */;
  //--font-family: /* property value */;
  //--line-height: /* property value */;
  //--color: /* property value */;
  //--link-color: /* property value */;
  //--link-hover-color: /* property value */;
  //--link-transition: /* property value */;
  //--loader-color: /* property value */;
  //--accordion-title-color: /* property value */;
  //--accordion-title-active-color: /* property value */;
  //--accordion-title-transition: /* property value */;
  --border-color: #D0D2D3;
  --label-color: #333435;
  //--label-background: /* property value */;
  //--button-color: /* property value */;
  //--button-background: /* property value */;
  //--button-hover-color: /* property value */;
  //--button-hover-background: /* property value */;
  //--button-transition: /* property value */;
  //--check-background: /* property value */;
  //--check-border: /* property value */;
  //--check-active-color: /* property value */;
  //--check-active-background: /* property value */;
  //--check-active-border: /* property value */;
  //--check-transition: /* property value */;
  //--tag-color: /* property value */;
  //--tag-background: /* property value */;
  //--tag-hover-color: /* property value */;
  //--tag-hover-background: /* property value */;
  //--tag-transition: /* property value */;
  //--pagination-nav-color: /* property value */;
  //--pagination-nav-background: /* property value */;
  //--pagination-nav-hover-color: /* property value */;
  //--pagination-nav-hover-background: /* property value */;
  //--pagination-nav-disabled-opacity: /* property value */;
  //--pagination-nav-transition: /* property value */;
  //--pagination-number-color: /* property value */;
  //--pagination-number-background: /* property value */;
  //--pagination-number-hover-color: /* property value */;
  //--pagination-number-hover-background: /* property value */;
  //--pagination-number-active-color: /* property value */;
  //--pagination-number-active-background: /* property value */;
  //--pagination-number-transition: /* property value */;
}
</style>
